<p-dialog header="Header" [(visible)]="visible" [modal]="true" [style]="{ width: info.width }">
    <div style="margin:0" class="grid w-full">
        <div class="flex justify-content-center col-12">
            <i style="font-size: 100px; " [style]="{color: info.iconColor}" class='bx {{info.icon}}'></i>
        </div>
        <div class="flex flex-column gap-3 col-12 px-5 text-center">
            <div>
                <span class="label-title-confirm font-title-bold">{{info.title}}</span>
            </div>
            <div>
                <span class="label-description-confirm font-subtitle-regular">{{info.detail}}</span>
            </div>
        </div>
        <div class="col-12 flex gap-3 px-5">
            <div class="w-full">
                <p-button (onClick)="cerrar()"  [style]="{'width':'100%','color':'white', 'background':'var(--color-primario)'}" class="btn-submit" label="Cerrar"></p-button>
            </div>
        </div>
    </div>
</p-dialog>